export const inputStyles = {
  mb: { xs: 2, md: 3 },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#e5e5e5",
      borderRadius: "8px",
    },
  },
};
